import { connect, MapStateToProps } from 'react-redux';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { Props } from './Custom';

type StateProps = Pick<
  Props,
  | 'isCurrentUserCoreMember'
  | 'moduleVersion'
  | 'title'
  | 'customtext'
  | 'imageDeviation'
  | 'backgroundType'
  | 'imageDisplayMode'
  | 'imageTint'
  | 'pattern'
  | 'gradient'
  | 'color'
>;

type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const isCurrentUserCoreMember = getCurrentUserHasCore(state);
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const {
    title,
    image: imageDeviationId,
    customtext,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  } = getModuleData(state, ownProps.moduleId);
  const imageDeviation = getDeviationById(state, imageDeviationId);
  return {
    isCurrentUserCoreMember,
    moduleVersion,
    title,
    customtext,
    imageDeviation,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  };
};

export default connect(mapStateToProps);
